import PillList from './PillList.jsx';
import RangeMetric from './RangeMetric.jsx';

export default function StructuredListItem({ item, options = {} }) {
  if (!item || typeof item !== 'object') {
    return null;
  }

  const title = typeof item.title === 'string' ? item.title.trim() : '';
  const subtitle = typeof item.subtitle === 'string' ? item.subtitle.trim() : '';
  const body = typeof item.body === 'string' ? item.body.trim() : '';

  const showPills = options.showPills !== false;
  const showMetrics = options.showMetrics !== false;

  const pills = Array.isArray(item.pills) ? item.pills : [];
  const metrics = Array.isArray(item.metrics) ? item.metrics : [];

  if (!title && !subtitle && !body && pills.length === 0 && metrics.length === 0) {
    return null;
  }

  return (
    <article className="savora-structured-list-item">
      <header className="savora-structured-list-item__header">
        <div className="savora-structured-list-item__heading">
          {title ? <h3 className="savora-structured-list-item__title">{title}</h3> : null}
          {subtitle ? <p className="savora-structured-list-item__subtitle">{subtitle}</p> : null}
        </div>

        {showPills ? <PillList pills={pills} /> : null}
      </header>

      {body ? <p className="savora-structured-list-item__body">{body}</p> : null}

      {showMetrics && metrics.length > 0 ? (
        <div className="savora-structured-list-item__metrics">
          {metrics.map((metric, index) => (
            <RangeMetric key={`${metric?.label || 'metric'}-${index}`} metric={metric} />
          ))}
        </div>
      ) : null}
    </article>
  );
}
